export default __webpack_public_path__ + "static/media/217.36327756.jpg";